import {Roadmap} from './Roadmap';

export const RoadmapRoute = () => <Roadmap />;
